import $ from 'jquery';

const defaultOptions = {
    message: ' ',
    css: { },
    overlayCSS: {
        backgroundColor: '#AAA',
        opacity: 0.3,
        cursor: 'wait'
    }
};

const options = $.blockUI && $.blockUI.defaults || {};
$.extend(options, defaultOptions);

function block(elm) {
    if(typeof $.blockUI !== 'function') return;

    if (!elm) {
        $.blockUI();
    } else {
        $(elm).block();
    }
}

function unblock(elm) {
    if(typeof $.unblockUI !== 'function') return;

    if (!elm) {
        $.unblockUI();
    } else {
        $(elm).unblock();
    }
}

export default {
    block,
    unblock,
    options
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/blockUI.js